export default __webpack_public_path__ + "eb66022385ca02058101fb72e1083030.svg";